import { Link } from 'react-router-dom';
import logo from '../../../assets/logo2026.png';

export function Logo() {
  return (
    <Link to="/menu">
      <img src={logo} alt="COOASGO" style={{ height: 64, width: 'auto' }} />
    </Link>
  );
}
